<script setup lang="ts">
// Home — rebuilt to mockup page 1 (M2 of ASKHVAC-REDESIGN.md).
import HeroHome from '../sections/home/HeroHome.vue'
import HowItWorks from '../sections/home/HowItWorks.vue'
import InfoGrid from '../sections/home/InfoGrid.vue'
import ClosingCta from '../sections/home/ClosingCta.vue'
</script>

<template>
    <HeroHome />
    <HowItWorks />
    <InfoGrid />
    <ClosingCta />
</template>
